<!-- 痕迹检测 -->
<template>
  <a-drawer
    :maskClosable="false"
    v-model:visible="visible"
    :title="`${bussBar.title}-工作质检`"
    @close="handleCancel"
    centered
    :width="391"
    :bodyStyle="{ padding: '0' }"
  >
    <a-spin :spinning="loading">
      <div class="wrap">
        <div class="conditionWrap">
          <div class="label">
            质检要求
            <span>
              {{
                bussBar?.orderData?.operationBehavior === 14
                  ? '(所有方式都要完成)'
                  : '(任意方式完成)'
              }}
            </span>
          </div>
          <div
            class="conditionItems z-flex-c"
            v-for="(item, index) in inspectionData.qualityInspectionRequireList"
            :key="index"
          >
            <div class="flex-c">
              <auth-img
                mode="ant"
                :width="44"
                :height="44"
                :src="imgMap[item?.calculateRuleType]"
                :preview="false"
              />
              <div class="condition">
                <div>{{ item.calculateRuleDetail }}</div>
                <div class="count">
                  已完成{{
                    item.calculateFinishCount > item.calculateRuleCount
                      ? item.calculateRuleCount
                      : item.calculateFinishCount
                  }}次
                </div>
              </div>
            </div>
            <div class="status z-flex-c">
              <auth-img
                mode="ant"
                :width="20"
                :height="20"
                :preview="false"
                :src="item.hasInspectionFinish ? success : fail"
              />
              <span class="txt">{{ item.hasInspectionFinish ? '已完成' : '未完成' }}</span>
            </div>
          </div>
        </div>
        <div class="uploadWrap">
          <div class="uploadItems" v-if="!inspectionData.hasTrace">
            <div class="uploadEvidence">
              <div class="text">上传凭证</div>
              <div class="tips">质检要求未达标，请上传凭证或填写补充说明</div>
              <div class="upload">
                <Upload
                  :maxLength="3"
                  :width="60"
                  :height="60"
                  @onSuccess="onSuccessUpload"
                  :files="bussBar.proofUrls"
                />
              </div>
              <div class="remark flex-c">
                <a-input
                  v-model:value="bussBar.remark"
                  placeholder="填写补充说明～"
                  :maxlength="30"
                  allowClear
                />
                <div class="count">{{ bussBar?.remark?.length ?? 0 }}/30</div>
              </div>
            </div>
          </div>
          <template v-if="inspectionData.hasNeedMedicalRecords">
            <div class="label">工作要求</div>
            <div class="uploadItems z-flex-c">
              <div class="uploadEvidence">
                <div class="text">补充诊疗记录</div>
                <div class="tips">
                  {{
                    bussBar?.medicalRecordData?.diagnosisList?.length
                      ? '已补充'
                      : '未检测到诊疗记录，请补充'
                  }}
                </div>
              </div>
              <template v-if="bussBar?.medicalRecordData?.diagnosisList?.length">
                <a-button @click="handleCreateOfflineCase" type="link">查看</a-button>
              </template>
              <a-button v-else @click="handleCreateOfflineCase" type="primary">去补充</a-button>
            </div>
          </template>
        </div>
      </div>
    </a-spin>
    <div class="footer">
      <a-space>
        <a-button @click="handleCancel">取消</a-button>
        <a-button type="primary" @click="submit">确定并完成工作质检</a-button>
      </a-space>
    </div>
  </a-drawer>
  <!-- 门诊病历弹窗部分 -->
  <medicalRecordsPoup
    :visible="uploadRecordVisible"
    :params="{
      ucDoctorId: bussBar.orderData?.ucDoctorId,
      doctorId: bussBar.orderData?.doctorId,
      ucPatientId: bussBar.orderData?.ucPatientId,
      patientId: bussBar.orderData?.patientId
    }"
    @savaData="savaData"
    @cancelClick="onClose"
    :needAPI="false"
    :keepAlive="true"
  ></medicalRecordsPoup>
</template>
<script setup>
import { ref, defineExpose, reactive } from 'vue'
import medicalRecordsPoup from '@/views/HealthRecord/HealthInfo/common/medicalRecordsPoup.vue'
import useMedicalRecordPop from './useMedicalRecordsPop'
import Upload from '@/components/Upload'
import { imgMap, success, fail, defaultBussBar } from './config'
import { queryQualityTraceDetection, uploadQualityProof } from '@/api/Todo/bdWorkorder'
import { debounce, get, set } from 'lodash-es'
import { saveOfflineCase } from '@/api/HealthRecord/index.js'
import { setStorage, getStorage } from '@/utils/auth'
import { message } from 'ant-design-vue'

const { onClose, uploadRecordVisible, handleCreateOfflineCase } = useMedicalRecordPop()
defineExpose({ initModal })
const visible = ref(false)
const bussBar = reactive({
  ...defaultBussBar
})
const loading = ref(true)
const inspectionData = ref({})
// 查询痕迹
const queryQualityTraceDetectionFn = () => {
  return new Promise((resolve, reject) => {
    const { workOrderId, ucUserId, taskId, operationBehavior } = bussBar.orderData
    const param = {
      workOrderId,
      adSubTaskId: taskId,
      operationBehavior,
      ucUserId,
      medicineRecordFlag: !!bussBar?.medicalRecordData?.diagnosisList?.length,
      qualityProofFlag: !!(bussBar.proofUrls?.length || bussBar?.remark)
    }
    queryQualityTraceDetection(param)
      .then(res => {
        inspectionData.value = res
        resolve(true)
      })
      .catch(() => {
        inspectionData.value = {}
        resolve(false)
      })
      .finally(() => {
        loading.value = false
      })
  })
}
function initModal(data) {
  const { orderData, cb, title } = data
  Object.assign(bussBar, defaultBussBar)
  bussBar.title = title
  bussBar.orderData = orderData
  bussBar.cb = cb
  visible.value = true
  getInspectionData()
}
// 上传图片成功
const onSuccessUpload = list => {
  bussBar.proofUrls = list
}

// 取消
const handleCancel = () => {
  storageInspection()
  visible.value = false
}

// 补充诊疗记录
const savaData = (type, data) => {
  bussBar.medicalRecordData = data ?? {}
  onClose()
}
// 提交
const submit = debounce(() => {
  const { hasTrace, hasNeedMedicalRecords } = inspectionData.value
  const medicineRecordFlag = !!bussBar?.medicalRecordData?.diagnosisList?.length
  const qualityProofFlag = !!(bussBar?.proofUrls?.length || bussBar?.remark)
  const arr = []
  if (!hasTrace && !qualityProofFlag) {
    message.error('请完成质检要求')
    return false
  }
  if (hasNeedMedicalRecords && !medicineRecordFlag) {
    message.error('请完成工作要求')
    return false
  }
  !hasTrace && arr.push(uploadQualityProofFn())
  hasNeedMedicalRecords && arr.push(supplementMedicalRecordFn())
  Promise.all(arr)
    .then(async res => {
      const data = await queryQualityTraceDetectionFn()
      // 处理子待办
      data && bussBar?.cb()
      visible.value = false
    })
    .catch(() => {
      //
    })
}, 500)
// 保存凭证
const uploadQualityProofFn = () => {
  return new Promise((resolve, reject) => {
    const { proofUrls, remark, orderData } = bussBar
    const { workOrderId, taskId, operationBehavior } = orderData
    const params = {
      proofUrls,
      remark,
      workOrderId,
      adSubTaskId: taskId,
      behavior: operationBehavior
    }
    uploadQualityProof(params)
      .then(() => {
        resolve(1)
      })
      .catch(() => {
        reject()
      })
  })
}
// 补充诊疗记录
const supplementMedicalRecordFn = () => {
  return new Promise((resolve, reject) => {
    saveOfflineCase({
      ...(bussBar?.medicalRecordData ?? {}),
      completeOrInvalidWorkOrder: false
    })
      .then(() => {
        resolve(1)
      })
      .catch(() => {
        reject()
      })
  })
}
// 暂存凭证
function storageInspection() {
  const data = getStorage('inspectionData') || {}
  try {
    const { proofUrls = [], remark, medicalRecordData } = bussBar
    const key = getStorageKey()
    const res = set(data, key, {
      proofUrls,
      remark,
      medicalRecordData
    })
    setStorage('inspectionData', res)
  } catch (error) {
    //
  }
}
// 获取暂存凭证
async function getInspectionData() {
  try {
    const data = getStorage('inspectionData') || {}
    const key = getStorageKey()
    const res = get(data, key, {})
    bussBar.proofUrls = res?.proofUrls ?? []
    bussBar.remark = res?.remark
    bussBar.medicalRecordData = res?.medicalRecordData
    loading.value = true
    await queryQualityTraceDetectionFn()
  } catch (error) {
    loading.value = true
    await queryQualityTraceDetectionFn()
  }
}
const getStorageKey = () => {
  const { workOrderId, taskId, operationBehavior } = bussBar?.orderData ?? {}
  return `${workOrderId}.taskId-${taskId}.behavior-${operationBehavior}`
}
</script>
<style scoped lang="scss">
.block {
  .label {
    margin-bottom: 12px;
    position: relative;

    span {
      font-weight: 400;
      font-size: 13px;
      color: #999999;
      margin-left: 8px;
    }

    &::before {
      content: '';
      position: absolute;
      top: 2px;
      left: -20px;
      width: 4px;
      height: 18px;
      background: #3f64ff;
      border-radius: 0 2px 2px 0;
    }
  }
}
.fz-5-16 {
  font-weight: 500;
  font-size: 16px;
  color: #333333;
  line-height: 22px;
}
.fz-4-12 {
  font-weight: 400;
  font-size: 12px;
  color: #999999;
  line-height: 18px;
}
.fz-5-15 {
  font-weight: 500;
  font-size: 15px;
  color: #333333;
  line-height: 21px;
}
.fz-4-14 {
  font-weight: 400;
  font-size: 14px;
  color: #999999;
  line-height: 20px;
}
.wrap {
  padding: 20px;
  .conditionWrap {
    @extend .block;
    .conditionItems {
      border: 1px solid #f0f0f0;
      border-radius: 8px;
      margin-bottom: 10px;
      padding: 9px 11px;

      .condition {
        @extend .fz-5-16;
        margin-left: 10px;
        .count {
          @extend .fz-4-12;
          margin-top: 5px;
        }
      }

      .status {
        @extend .fz-4-12;
        .txt {
          margin-left: 6px;
        }
      }
    }
  }

  .uploadWrap {
    @extend .block;
    margin-top: 12px;

    .uploadItems {
      padding: 16px;
      background: #f7f8fa;
      border: 1px dashed #b3b3b3;
      border-radius: 8px;
      margin-bottom: 24px;

      .uploadEvidence {
        .text {
          @extend .fz-5-16;
        }

        .tips {
          @extend .fz-4-12;
          color: #f45959;
          margin-top: 4px;
        }

        .upload {
          margin-top: 12px;
        }

        .remark {
          background: #edeef0;
          border-radius: 8px;
          width: 100%;
          height: 44px;
          padding: 11px 12px;

          ::v-deep(.ant-input-affix-wrapper) {
            flex: 1;
            &.ant-input-affix-wrapper-focused {
              outline: none;
              border: none;
              box-shadow: none;
            }
            .ant-input {
              background-color: transparent;
            }
            background-color: transparent;
            padding: initial;
            border: none;
            outline: none;
          }
          .count {
            @extend .fz-4-12;
            margin-left: 5px;
            width: 34px;
            text-align: right;
          }
        }
      }
    }
  }
}
.footer {
  position: fixed;
  bottom: 0;
  border-top: 1px solid #d9d9d9;
  padding: 15px;
  width: 391px;
  ::v-deep(.ant-space) {
    display: flex;
    justify-content: flex-end;
  }
}
</style>
